import { render, staticRenderFns } from "./read-only-questions.vue?vue&type=template&id=c16c76d8&scoped=true&"
import script from "./read-only-questions.vue?vue&type=script&lang=js&"
export * from "./read-only-questions.vue?vue&type=script&lang=js&"
import style0 from "./read-only-questions.vue?vue&type=style&index=0&id=c16c76d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c16c76d8",
  null
  
)

component.options.__file = "read-only-questions.vue"
export default component.exports